import { AUTH_CODE_LABEL, AUTH_CODE_LENGTH, AUTH_CODE_PLACEHOLDER } from 'common/constants/auth';
import { AuthTextField } from 'pages/Auth/components/AuthTextField';
import { AuthenticationInputProps } from './AuthenticationInput.props';

const normalizeFieldMessages = (value?: string | string[]) => {
  if (!value) {
    return [];
  }

  return Array.isArray(value) ? value : [value];
};

const AuthenticationInput = ({ disabled = false, formState, handleBlur, handleChange, inputRef, onKeyDown }: AuthenticationInputProps) => {
  const { dbErrors, errors, touched, values } = formState;
  const validationMessages = normalizeFieldMessages(errors?.otp);
  const serverMessages = normalizeFieldMessages(dbErrors?.otp);
  const helperText = touched.otp ? validationMessages[0] : undefined;
  const error = Boolean(helperText || serverMessages[0]);

  return (
    <AuthTextField
      autoComplete="one-time-code"
      disabled={disabled}
      id="enter-user-otp"
      slotProps={{
        htmlInput: {
          inputMode: 'numeric',
          maxLength: AUTH_CODE_LENGTH,
          onBlur: handleBlur,
          pattern: '[0-9]*',
        },
      }}
      name="otp"
      label={AUTH_CODE_LABEL}
      placeholder={AUTH_CODE_PLACEHOLDER}
      type="text"
      error={error}
      helperText={helperText}
      value={values.otp || ''}
      inputRef={inputRef}
      onChange={handleChange}
      onKeyDown={onKeyDown}
    />
  );
};

export default AuthenticationInput;
